import React, { useState } from "react";
import axios from "axios";
import {useNavigate } from "react-router-dom";

function ExcelUpload() {
  const [file, setFile] = useState(null);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!file) return alert("Please select a file first!");

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await axios.post(
        "https://agaram.ematixsolutions.com/api/products/upload-excel",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      alert("Upload success ✅");
      console.log(response.data);
    } catch (error) {
  const msg = error.response?.data?.error
    || error.response?.data?.message
    || error.message;
  console.error("Upload failed ❌", msg);
  alert(`Upload failed: ${msg}`);
}

  };

  return (
    <div>
      <h2>Upload Product Excel</h2>
      <input type="file" accept=".xlsx,.xls" onChange={handleFileChange} />
      <button onClick={handleUpload}>Upload</button>
    </div>
  );
}

export default ExcelUpload;
